// extracted by mini-css-extract-plugin
module.exports = {"loaderImage":"Loader_loaderImage__lKh90","absolute":"Loader_absolute__2sCRw","loaderWrapper":"Loader_loaderWrapper__2vK1T","label":"Loader_label__3oM48"};